import { render, staticRenderFns } from "./Page_WindowShopWindow.vue?vue&type=template&id=5d6bab86&scoped=true&"
import script from "./Page_WindowShopWindow.vue?vue&type=script&lang=js&"
export * from "./Page_WindowShopWindow.vue?vue&type=script&lang=js&"
import style0 from "./Page_WindowShopWindow.vue?vue&type=style&index=0&id=5d6bab86&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5d6bab86",
  null
  
)

export default component.exports